import type {
  ConfigUrls,
  Category,
} from 'hb-react/frontoffice/apps/Forum/types';
import AppHeaderLinkButton from 'hb-react/shared/apps/PageCustomizables/components/AppHeaderLinkButton';
import type { AppPageConfig } from 'hb-react/types';

interface HeaderControls {
  appPageConfig: AppPageConfig;
  configUrls?: ConfigUrls;
  canCreateDiscussion?: boolean;
  isPreview?: boolean;
  topicId?: number;
}

// getForumHeaderControls also used on BO
export const getForumHeaderControls = ({
  appPageConfig,
  configUrls,
  canCreateDiscussion,
  isPreview = false,
  topicId,
}: HeaderControls) => {
  if (!appPageConfig) {
    return {};
  }

  const {
    secondary_button_enabled: secondaryButtonEnabled,
    secondary_button_url: secondaryButtonUrl,
    secondary_button_label: secondaryButtonLabel,
  } = appPageConfig.config;

  const controls = [
    canCreateDiscussion && (
      <AppHeaderLinkButton
        url={configUrls?.newDiscussionUrl() ?? ''}
        label={s__('Forum|New discussion')}
        isPreview={isPreview}
      />
    ),
    secondaryButtonEnabled && secondaryButtonUrl && !topicId && (
      <AppHeaderLinkButton
        url={secondaryButtonUrl}
        label={secondaryButtonLabel ?? ''}
        isPreview={isPreview}
        variant="secondary"
        target="_blank"
      />
    ),
  ].filter(Boolean);

  return {
    controls,
  };
};

export const transformCategories = (categories: Category[]) =>
  categories.map((c) => ({
    name: `cat_${c.id}`,
    label: c.name,
    query: {
      [`cat_${c.id}`]: c.id,
    },
  }));
